/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type HappeningsContainer_lists$ref = any;
export type HappeningsContainerQueryVariables = {|
  first?: ?number,
  after?: ?string,
  startingAfter?: ?any,
  endingBefore?: ?any,
  active?: ?boolean,
|};
export type HappeningsContainerQueryResponse = {|
  +lists: ?{|
    +$fragmentRefs: HappeningsContainer_lists$ref
  |}
|};
export type HappeningsContainerQuery = {|
  variables: HappeningsContainerQueryVariables,
  response: HappeningsContainerQueryResponse,
|};
*/


/*
query HappeningsContainerQuery(
  $first: Int = 100
  $after: String
  $startingAfter: DateTime
  $endingBefore: DateTime
  $active: Boolean = true
) {
  lists {
    ...HappeningsContainer_lists_4FAQLc
    id
  }
}

fragment HappeningCell_happening on HeroOffer {
  id
  title
  url
  imageUrl
  startDate
  endDate
}

fragment HappeningsContainer_lists_4FAQLc on Lists {
  heroOffers(first: $first, after: $after, startingAfter: $startingAfter, endingBefore: $endingBefore, active: $active) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        ...HappeningCell_happening
        __typename
      }
      cursor
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": 100,
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "startingAfter",
    "type": "DateTime"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "endingBefore",
    "type": "DateTime"
  },
  {
    "defaultValue": true,
    "kind": "LocalArgument",
    "name": "active",
    "type": "Boolean"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "active",
    "variableName": "active"
  },
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "endingBefore",
    "variableName": "endingBefore"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "startingAfter",
    "variableName": "startingAfter"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HappeningsContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Lists",
        "kind": "LinkedField",
        "name": "lists",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "FragmentSpread",
            "name": "HappeningsContainer_lists"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HappeningsContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Lists",
        "kind": "LinkedField",
        "name": "lists",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "HeroOfferConnection",
            "kind": "LinkedField",
            "name": "heroOffers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "HeroOfferEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HeroOffer",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "imageUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v1/*: any*/),
            "filters": [
              "active",
              "startingAfter",
              "endingBefore"
            ],
            "handle": "connection",
            "key": "HappeningsContainer_heroOffers",
            "kind": "LinkedHandle",
            "name": "heroOffers"
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "HappeningsContainerQuery",
    "operationKind": "query",
    "text": "query HappeningsContainerQuery(\n  $first: Int = 100\n  $after: String\n  $startingAfter: DateTime\n  $endingBefore: DateTime\n  $active: Boolean = true\n) {\n  lists {\n    ...HappeningsContainer_lists_4FAQLc\n    id\n  }\n}\n\nfragment HappeningCell_happening on HeroOffer {\n  id\n  title\n  url\n  imageUrl\n  startDate\n  endDate\n}\n\nfragment HappeningsContainer_lists_4FAQLc on Lists {\n  heroOffers(first: $first, after: $after, startingAfter: $startingAfter, endingBefore: $endingBefore, active: $active) {\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    edges {\n      node {\n        id\n        ...HappeningCell_happening\n        __typename\n      }\n      cursor\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '11c255f7ae35d3a39e486c621621106b';

module.exports = node;
